import axios from '../config/axiosConfig';

const API_URL = '/actions/';

// Get all actions
const getActions = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Get actions by project
const getActionsByProject = async (projectId) => {
  const response = await axios.get(API_URL + 'project/' + projectId);
  return response.data;
};

// Get single action
const getAction = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

// Create action
const createAction = async (actionData) => {
  const response = await axios.post(API_URL, actionData);
  return response.data;
};

// Update action
const updateAction = async (id, actionData) => {
  const response = await axios.put(API_URL + id, actionData);
  return response.data;
};

// Delete action
const deleteAction = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

// Assign targets to actions that have none
const assignTargets = async (projectId) => {
  const response = await axios.post(API_URL + 'assign-targets/' + projectId);
  return response.data;
};

// Bulk delete actions
const bulkDelete = async (actionIds) => {
  const response = await axios.post(API_URL + 'bulk-delete', { actionIds });
  return response.data;
};

// Generate campaign from selected actions
const generateCampaign = async (actionIds, name, objective) => {
  const response = await axios.post(API_URL + 'generate-campaign', { actionIds, name, objective });
  return response.data;
};

const actionService = {
  getActions,
  getActionsByProject,
  getAction,
  createAction,
  updateAction,
  deleteAction,
  assignTargets,
  bulkDelete,
  generateCampaign,
};

export default actionService;